import { Component } from '@angular/core';
import { membersuitePaymentLineItemEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Payment Line Items') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitepaymentlineitem-form',
    templateUrl: './membersuitepaymentlineitem.form.component.html'
})
export class membersuitePaymentLineItemFormComponent extends BaseFormComponent {
    public record!: membersuitePaymentLineItemEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

